let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gnfQV")).then(() => parcelRequire('4ECv0'));